import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import { goBack } from '@comm/BackBtn';

import { queryDepartmentOpportunity } from '@api/crm/crm';

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: [{ key: 0 }],
    };
  }

  componentDidMount() {
    this.getData();
  }

  submit = e => {
    e.preventDefault();
    const { handleSubmit } = this.props;
    const { config } = this.state;
    this.props.form.validateFields(err => {
      if (!err) {
        const params = {
          uuid: this.props.params.uuid,
          config,
        };
        handleSubmit(params);
      }
    });
  };

  getData = () => {
    queryDepartmentOpportunity({
      uuid: this.props.params.uuid,
    }).then(res => {
      res.data.map((item, index) => {
        item.key = index;
        return item;
      });
      this.setState({
        config: res.data,
      });
    });
  };

  addConfig = () => {
    const { config } = this.state;
    const key = config[config.length - 1].key + 1;
    this.setState({
      config: [...config, { key }],
    });
  };

  subConfig = key => {
    const { config } = this.state;
    const configArr = config.filter(item => {
      return item.key !== key;
    });
    this.setState({
      config: configArr,
    });
  };

  handleChange = (type, index) => {
    return e => {
      const { config } = this.state;
      config[index][type] = e.target.value;
      this.setState({
        config,
      });
    };
  };

  render() {
    const { config } = this.state;
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="阶段设置">
        <Form onSubmit={this.submit} className="">
          {config.map((item, index) => {
            return (
              <Row key={item.key}>
                <Col span={6}>
                  <FormItem label="阶段名称" {...ItemLayout}>
                    {getFieldDecorator(`name${item.key}`, {
                      rules: [{ required: true, message: '请填写阶段名称!' }],
                      initialValue: item.name,
                    })(<Input onChange={this.handleChange('name', index)} />)}
                  </FormItem>
                </Col>
                <Col span={7}>
                  <FormItem label="阶段百分号" {...ItemLayout}>
                    {getFieldDecorator(`percentage${item.key}`, {
                      rules: [{ required: true, message: '请填写阶段百分号!' }],
                      initialValue: item.percentage,
                    })(<Input onChange={this.handleChange('percentage', index)} addonAfter="%" />)}
                  </FormItem>
                </Col>
                <Col span={6}>
                  <FormItem label="排序" {...ItemLayout}>
                    {getFieldDecorator(`index${item.key}`, {
                      rules: [{ required: true, message: '请填写排序!' }],
                      initialValue: item.index,
                    })(<Input onChange={this.handleChange('index', index)} />)}
                  </FormItem>
                </Col>
                <Col span={5}>
                  <FormItem style={{ textAlign: 'right' }}>
                    {config.length - 1 === index ? (
                      <Button type="primary" onClick={this.addConfig} style={{ marginRight: 10 }}>
                        +
                      </Button>
                    ) : null}
                    {config.length === 1 ? null : (
                      <Button onClick={() => this.subConfig(item.key)}>-</Button>
                    )}
                  </FormItem>
                </Col>
              </Row>
            );
          })}

          <Row>
            <Col span={24} style={{ marginBottom: 15, textAlign: 'right' }}>
              <Button style={{ marginRight: 10 }} type="primary" htmlType="submit">
                确定
              </Button>
              <Button onClick={goBack}>取消</Button>
            </Col>
          </Row>
        </Form>
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/department/stage/FormStage.js